import {computeCoverPropertiesWithSuffix} from './media';

const applyCoverProperties = (player, backgroundWrapper, ratio = 16/9) => {
	Object.assign(
		player.style,
		computeCoverPropertiesWithSuffix(
			backgroundWrapper,
			ratio,
		),
	);
}

export default () => {
	const modules = document.querySelectorAll('.image-video-background-element');
	if ( ! modules )
		return;

	[...modules].forEach(module => {
		const backgroundWrapper = module.querySelector('.link-vimeo');

		if ( backgroundWrapper ) {
			const player = backgroundWrapper.querySelector('iframe');

			applyCoverProperties(player, backgroundWrapper);

			window.addEventListener('resize', () => {
				applyCoverProperties(player, backgroundWrapper);
			});
		}
	});

	const textImageVideoElementModules = document.querySelectorAll('.text-image-video-element');

	[...textImageVideoElementModules].forEach(module => {
		const backgroundWrapper = module.querySelector('.link-vimeo');

		if ( backgroundWrapper ) {
			const player = backgroundWrapper.querySelector('iframe');

			let ratio = 16 / 8;

			applyCoverProperties(player, backgroundWrapper, ratio);

			window.addEventListener('resize', () => {
				applyCoverProperties(player, backgroundWrapper, ratio);
			});
		}
	})
}



// WEBPACK FOOTER //
// ./scripts/modules/video-background.js